import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateUserLevelUp } from './use-update-user-level-up'

export const UserLevelUp = memo(() => {
  useUpdateUserLevelUp()

  const notifyUserLevelUpList = useGlobalStore(
    useShallow((state) => {
      return state.notifyUserLevelUpList
    }),
  )

  return (
    <div className="w-screen h-screen flex items-center justify-center flex-col">
      {notifyUserLevelUpList.map(
        (toast, index) => index === 0 && <Toast key={toast.id} toast={toast} />,
      )}
    </div>
  )
})
